export const VIEW_KEY_HEADER = 'X-TWL-View-Key';

export function getViewKeyHeader(viewKey: string) {
  return viewKey ? {[VIEW_KEY_HEADER]: viewKey} : {};
}

export interface ViewKeyOptions {
  viewKey?: string;
}
